import api from '@/services/api'

export default {
    getStaticPage(payload) {
        return api.get(`static_pages`, { params: payload })
            .then(response => response.data,
                error => error.response.data)
    },
}